import { useState } from 'react';
import OrderByOptionService from './OrderByOptionService';

function useManageOrderByOptions() {
  const [orderByOptions, setOrderByOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refreshOrderByOptions = async () => {
    setIsLoading(true);
    try {
      const response = await OrderByOptionService.getOrderByOptions();
      setOrderByOptions(response.data);
      setError(null);
    } catch (err) {
      console.log(err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const addOrderByOption = async (data) => {
    let result = true;
    setIsLoading(true);
    try {
      await OrderByOptionService.addOrderByOption(data);
      refreshOrderByOptions();
    } catch (err) {
      result = false;
      setError(err.response?.data?.message || 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const editOrderByOption = async (id, data) => {
    setIsLoading(true);
    try {
      await OrderByOptionService.editOrderByOption(id, data);
      refreshOrderByOptions();
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteOrderByOption = async (id) => {
    setIsLoading(true);
    try {
      await OrderByOptionService.deleteOrderByOption(id);
      refreshOrderByOptions();
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleSuspend = async (id, enable) => {
    try {
      const response = await OrderByOptionService.toggleSuspend(id, enable);
      setOrderByOptions(prev =>
        prev.map(o => (o.id === id ? response.data : o))
      );
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Toggle suspend failed.');
      throw err;
    }
  };

  return {
    orderByOptions,
    isLoading,
    error,
    addOrderByOption,
    editOrderByOption,
    deleteOrderByOption,
    toggleSuspend,
    refreshOrderByOptions
  };
}

export default useManageOrderByOptions;
